module.exports = __webpack_public_path__ + "static/media/banner2.8d24bb2a.jpg";